<template>
  <div class="home max-height">
    <div class="mb-6 flex-align-start">
      <div class="form-title flex-0 flex-shrink-0 flex-justify-end mt-2">
        预警提醒用户：
      </div>
      <form-item
        v-model="email"
        class="mr-2"
        style="width: 500px"
        placeholder="请输入邮箱"
        required
        type="text"
      />
      <v-btn
        :loading="btnLoading"
        color="primary"
        height="30"
        depressed
        @click="saveWarnEmail"
      >保存</v-btn>
    </div>
    <div class="home__tabs">
      <v-tabs v-model="tab" @change="changeTab">
        <v-tab class="py-2">服务器信息</v-tab>
        <v-tab class="py-2">JVM信息</v-tab>
        <v-tab class="py-2">Tomcat信息</v-tab>
        <v-tab class="py-2">磁盘监控</v-tab>
        <v-tab class="py-2">内存信息</v-tab>
      </v-tabs>
      <v-divider />

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="index in 5" :key="index">
          <template v-if="index !== 4">
            <div class="mt-3 ml-5" style="color: #333">
              上次更新时间：{{ lastUpdateTime }}
              <a href="javascript:void(0)" class="ml-3" @click="getData">立即更新</a>
            </div>
            <v-data-table
              :headers="tableHeaders"
              :items="tableItems"
              class="mt-3 px-5 max-width header-grey"
              hide-default-footer
              no-data-text="暂无查询数据"
              disable-sort
              :loading="loading"
              loading-text="加载中..."
            >
              <template v-slot:item.param="{ item }">
                <div class="config-value" :style="computedStyle(item.param)">
                  {{ item.param }}
                </div>
              </template>
            </v-data-table>
          </template>
          <template v-if="index === 4">
            <div ref="echartsRef" class="echarts" />
            <div style="padding-left: 180px">
              <span style="font-size: 30px">{{ diskInfo.displayText }}</span>
              <a
                href="javascript:void(0)"
                class="ml-3"
                @click="(warningData = ''), (showDialog = true)"
              >设定磁盘空间预警值
              </a>
            </div>
          </template>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <ReDialog
      title="设定磁盘空间预警值"
      :value.sync="showDialog"
      @ok="handleSaveData"
    >
      <form-item
        v-model="warningData"
        type="number"
        placeholder="磁盘空间预警值"
        pattern="justInteger"
      />
    </ReDialog>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import * as echarts from 'echarts';
import ReDialog from '@/components/reDialog/index.vue';

export default {
  name: 'Home',
  components: {
    ReDialog,
  },
  data() {
    return {
      msg: {},
      tab: 0,
      tableHeaders: [
        {
          text: '参数',
          value: 'param',
        },
        {
          text: '描述',
          value: 'description',
        },
        {
          text: '当前值',
          value: 'currentValue',
        },
      ],
      tableItems: [
        {
          configValue: 'server.name',
          configDesc: '服务器名称',
          currentValue: 'CTMS-CRO-SERVER',
        },
      ],
      lastUpdateTime: '',
      loading: false,
      myChart: null,
      diskInfo: {},
      warningData: '',
      showDialog: false,
      email: '',
      btnLoading: false,
    };
  },
  mounted() {
    this.$http.get(this.$api.commonVersion, { data: '' }).then((res) => {
      this.msg = res.result;
    });
    this.getData();
    this.$http.get(this.$api.getWarnEmailOrMemory, { data: '' }).then((res) => {
      this.email = res.result.SYSTEM_WARN_EMAIL_KEY || '';
      // this.warningData = res.result.memory || ''
    });
  },
  methods: {
    getData() {
      this.loading = true;
      let tabName = '';
      switch (this.tab) {
        case 0:
          tabName = 'server';
          break;
        case 1:
          tabName = 'jvm';
          break;
        case 2:
          tabName = 'tomcat';
          break;
        case 3:
          tabName = 'disk';
          break;
        case 4:
          tabName = 'memory';
          break;
        default:
          break;
      }
      this.$http.get(this.$api.getMonitorData + `/${tabName}`).then((res) => {
        console.log(res.result);
        this.loading = false;
        if (this.tab !== 3) {
          this.lastUpdateTime = res.result.lastUpdateTime;
          this.tableItems = res.result.monitorItems;
        } else {
          this.diskInfo = res.result;
          if (!this.myChart) {
            this.myChart = echarts.init(this.$refs.echartsRef[0]);
          }
          const _color = res.result.isExceedWarning ? '#ff4d4f' : '#50a249';
          const options = {
            color: [_color],
            series: [
              {
                type: 'gauge',
                progress: {
                  show: true,
                  width: 18,
                },
                axisLine: {
                  lineStyle: {
                    width: 18,
                  },
                },
                axisTick: {
                  show: true,
                },
                splitLine: {
                  length: 15,
                  lineStyle: {
                    width: 2,
                    color: '#999',
                  },
                },
                axisLabel: {
                  distance: 25,
                  color: '#999',
                  fontSize: 16,
                },
                anchor: {
                  show: true,
                  showAbove: true,
                  size: 25,
                  itemStyle: {
                    borderWidth: 10,
                    borderColor: _color,
                  },
                },
                title: {
                  show: false,
                },
                detail: {
                  valueAnimation: true,
                  fontSize: 40,
                  offsetCenter: [0, '70%'],
                  formatter: (val) => {
                    return val + '%';
                  },
                },
                data: [
                  {
                    value: this.diskInfo.usageRate || 0,
                  },
                ],
              },
            ],
          };
          setTimeout(() => {
            this.myChart.setOption(options);
          }, 200);
        }
      });
    },
    computedStyle(val) {
      if (!val) return {};
      // 定义样式映射，使代码更清晰易维护
      const styleMap = [
        {
          keywords: ['cpu', 'threads', 'tomcat.sessions', 'physical'],
          // 绿色
          style: {
            borderColor: '#50a249',
            color: '#50a249',
            backgroundColor: '#f8ffee',
          },
        },
        {
          keywords: ['process', 'memory', 'runtime'],
          // 紫色
          style: {
            borderColor: '#531DAB',
            color: '#531DAB',
            backgroundColor: '#F9F0FF', // 修正拼写错误
          },
        },
        {
          keywords: ['classes'],
          // 橘色
          style: {
            borderColor: '#D46B08',
            color: '#D46B08',
            backgroundColor: '#FFF7E6',
          },
        },
        {
          keywords: ['gc.max', 'gc.memory', ''],
          // 粉
          style: {
            borderColor: '#C41D7F',
            color: '#C41D7F',
            backgroundColor: '#FFF0F6',
          },
        },
        {
          keywords: ['buffer'],
          // 薄荷绿
          style: {
            borderColor: '#08979C',
            color: '#08979C',
            backgroundColor: '#E6FFFB',
          },
        },
        {
          keywords: ['gc.pause'],
          // 薄荷绿
          style: {
            borderColor: '#0958D9',
            color: '#0958D9',
            backgroundColor: '#E6F4FF',
          },
        },
      ];

      // 遍历样式映射，找到匹配的样式
      for (const item of styleMap) {
        if (item.keywords.some((keyword) => val.indexOf(keyword) !== -1)) {
          return item.style;
        }
      }

      // 返回默认样式，确保始终有样式应用
      return {
        borderColor: '#ccc',
        color: '#333',
        backgroundColor: '#f5f5f5',
      };
    },
    changeTab() {
      console.log(this.tab);
      this.getData();
    },
    handleSaveData() {
      // if (!this.warningData) {
      //   this.$message.error('请输入预警值');
      //   return;
      // }
      this.$http
        .post(this.$api.saveWarnMemory, {
          data: {
            value: this.warningData || 0,
          },
        })
        .then(() => {
          this.$message.success('保存成功');
          this.getData();
        })
        .finally(() => {
          this.showDialog = false;
        });
    },
    saveWarnEmail() {
      this.btnLoading = true;
      this.$http
        .post(this.$api.saveWarnEmail, {
          data: {
            value: this.email,
          },
        })
        .then(() => {
          this.$message.success('保存成功');
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
  },
};
</script>
<style scoped lang="scss">
.home {
  display: flex;
  flex-direction: column;
  &__tabs {
    flex: 1 0 0;
    background: #fff;
  }
  .config-value {
    padding: 2px 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: fit-content;
    background: #f5f5f5;
  }
  .echarts {
    width: 500px;
    height: 400px;
  }
}
</style>
